import React from 'react'
import ReactDOM from 'react-dom'
import cn from 'classnames'

import { Store } from '../Store'

import CollapseIcon from '../AppMenu/icons/CollapseIcon'

const GoLiveSelfServe = React.lazy(() => import('../GoLiveSelfServe'))
const TeamSwitcher = React.lazy(() => import('../TeamSwitcher'))
const Profile = React.lazy(() => import('../Profile'))
const Breadcrumbs = React.lazy(() => import('../Breadcrumbs'))

type Props = {
    isSidebarOpen: boolean,
    toggleSidebar: () => void
}

function TopHeader (props: Props) {
    const { state } = React.useContext(Store)

    const hasMultipleTeams = React.useMemo(() => {
        return Object.keys(state.teams.availableTeams).length > 1
    }, [state.teams.availableTeams])

    React.useEffect(() => {
        const header = document.getElementsByClassName('js-header-react')?.[0]

        if (header && state.fullScreen) {
            header.classList.add('__is-fullscreen')
        } else {
            header.classList.remove('__is-fullscreen')
        }
    }, [state.fullScreen])

    return state.topHeader && (
        <>
            <div className={cn('pageLayout-header-left', { __collapsed: !props.isSidebarOpen })}>
                <div className="pageLayout-logo">
                    <a href={state.homeRoute}>
                        <img src="/images/logo.svg" alt=""/>
                    </a>
                </div>
                <button
                    aria-label={props.isSidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
                    aria-expanded={props.isSidebarOpen}
                    className="toggle-sidebar"
                    type="button"
                    onClick={props.toggleSidebar}
                >
                    <CollapseIcon/>
                </button>
            </div>

            <div className="pageLayout-header-breadcrumbs">
                <React.Suspense fallback="...">
                    <Breadcrumbs/>
                </React.Suspense>
            </div>

            <div className="pageLayout-header-right">
                {(state.campaign && state.campaign.status === 'tester' && state.campaign?.selfServe?.supported) && (
                    <React.Suspense fallback="...">
                        <GoLiveSelfServe/>
                    </React.Suspense>
                )}

                {hasMultipleTeams && (
                    <div className="pageLayout-team-switcher">
                        <React.Suspense fallback="...">
                            <TeamSwitcher {...state.teams}/>
                        </React.Suspense>
                    </div>
                )}

                {state.profile.user.client && state?.client?.name && (
                    <div className="pageLayout-user-organization">
                        {state.client.name}
                    </div>
                )}

                <React.Suspense fallback="...">
                    <Profile {...state.profile}/>
                </React.Suspense>
            </div>
        </>
    )
}

export default function (props: Props) {
    return ReactDOM.createPortal(
        <TopHeader {...props}/>,
        document.getElementsByClassName('js-header-react')[0]
    )
}
